export default "__VITE_ASSET__DUXOsNPx__"